import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import FalconCloseButton from '../common/FalconCloseButton';
import { getWorkbenchMobileListScrollEl } from '../../utils/mobileScrollChrome';

/** 上下文岛右岛：页面内列表搜索（加载态由列表区进度条/条数栏承担，不干扰输入框） */
const MobileIslandSearchField = ({
	inputRef,
	inputId,
	name,
	value = '',
	onChange,
	onSubmit,
	onDismiss,
	onFocusStateChange,
	placeholder = '搜索…',
	autoFocus = false,
}) => {
	const handleSubmit = useCallback(
		(event) => {
			event.preventDefault();
			onSubmit?.(event);
		},
		[onSubmit],
	);

	const handleFocus = useCallback(
		(event) => {
			const scrollEl = getWorkbenchMobileListScrollEl();
			const scrollTop = scrollEl?.scrollTop ?? 0;
			onFocusStateChange?.(true);
			// iOS：聚焦时禁止列表滚动把 fixed 搜索框里的光标扯偏
			requestAnimationFrame(() => {
				if (scrollEl != null) {
					scrollEl.scrollTop = scrollTop;
				}
				event.target?.focus?.({ preventScroll: true });
			});
		},
		[onFocusStateChange],
	);

	return (
		<Form className='position-relative search-box search-box--island workbench-island-search-field' onSubmit={handleSubmit}>
			<Form.Label htmlFor={inputId} className='visually-hidden'>
				{placeholder}
			</Form.Label>
			<Form.Control
				ref={inputRef}
				id={inputId}
				name={name ?? inputId}
				type='search'
				inputMode='search'
				enterKeyHint='search'
				placeholder={placeholder}
				aria-label={placeholder}
				className='rounded-pill search-input'
				value={value}
				onChange={(event) => onChange(event.target.value)}
				onFocus={handleFocus}
				onBlur={() => onFocusStateChange?.(false)}
				autoComplete='off'
				autoFocus={autoFocus}
			/>
			<FontAwesomeIcon icon='search' className='position-absolute search-box-icon' />
			<div className='search-box-close-btn-container'>
				<FalconCloseButton size='sm' noOutline className='fs-11' onClick={onDismiss} aria-label='关闭搜索' />
			</div>
		</Form>
	);
};

MobileIslandSearchField.propTypes = {
	inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
	inputId: PropTypes.string.isRequired,
	name: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onSubmit: PropTypes.func,
	onDismiss: PropTypes.func,
	onFocusStateChange: PropTypes.func,
	placeholder: PropTypes.string,
	autoFocus: PropTypes.bool,
};

export default MobileIslandSearchField;
